import React, {
  createContext, useContext, useMemo,
} from 'react';
import { useAudios } from './useAudios';

export const AudiosContext = createContext();

const useUploadAudioContext = () => useContext(AudiosContext);

export const useRefetchAudio = () => {
  const { refetchAudio } = useUploadAudioContext();
  return refetchAudio;
};

export const useUpdateAudio = () => {
  const { updateAudio } = useUploadAudioContext();
  return updateAudio;
};

export function AudiosProvider({
  children, initialPageSize, authorId, bookId, triggerRefresh, storyId,
}) {
  const {
    audios,
    isLoading,
    refetchAudio,
    updateAudio,
    upsertAudio,
    patchAudio,
    ensureAudios,
    pinAudioIds,
    rememberAudioBaseUrl,
    audioBaseUrl,
    currentPage,
    setCurrentPage,
    totalCount,
    handleSearchSubmit,
    searchTerm,
    currentPageSize,
    setCurrentPageSize,
  } = useAudios(initialPageSize, authorId, bookId, triggerRefresh, storyId);

  const contextValue = useMemo(
    () => ({
      currentPage,
      setCurrentPage,
      totalCount,
      currentPageSize,
      setCurrentPageSize,

      audios,
      isLoading,
      refetchAudio,
      updateAudio,
      upsertAudio,
      patchAudio,
      ensureAudios,
      pinAudioIds,
      rememberAudioBaseUrl,
      audioBaseUrl,
      bookId,
      storyId,

      handleSearchSubmit,
      searchTerm,
    }),
    [
      currentPage,
      setCurrentPage,
      totalCount,
      currentPageSize,
      setCurrentPageSize,

      audios,
      isLoading,
      refetchAudio,
      updateAudio,
      upsertAudio,
      patchAudio,
      ensureAudios,
      pinAudioIds,
      rememberAudioBaseUrl,
      audioBaseUrl,
      bookId,
      storyId,

      handleSearchSubmit,
      searchTerm,
    ],
  );

  return (
    <AudiosContext.Provider value={contextValue}>
      { children }
    </AudiosContext.Provider>
  );
}
